/**
 * Ключ слота в pagesData для NEW_WINDOW: `{registryId}_win_{sessionId}`.
 */
export function registryFormIdFromSlotId(slotId: string): string {
  const s = String(slotId ?? '').trim()
  const m = /^(.+?)_(win|adj)_(.+)$/.exec(s)
  if (m && (m[2] === 'win' || m[2] === 'adj')) {
    return m[1]
  }
  return s
}

/** Слот NEW_WINDOW / adjacent: отдельный ключ в pagesData, не совпадает с registry id. */
export function isIsolatedPageSlotId(slotId: string): boolean {
  return /_(win|adj)_/.test(String(slotId ?? '').trim())
}

/** Ключ pagesData для setPageData: полный slot id маршрута, не registry actionId. */
export function resolvePageDataStorageKey(
  pageSlotId: string | undefined | null,
  registryActionId: string | undefined | null,
): string {
  const slot = String(pageSlotId ?? '').trim()
  if (slot) return slot
  return String(registryActionId ?? '').trim()
}

/**
 * Для NEW_WINDOW: поднять parent с закрытого _win_ на list-tab (2608), пока есть pagesData / openTabs.
 */
export function resolveStableParentPageSlotId(
  candidateParent: string | undefined | null,
  pagesData: Record<string, unknown>,
  openTabIds?: Iterable<string>,
): string | undefined {
  let cur = String(candidateParent ?? '').trim()
  if (!cur || cur === 'home') return undefined

  const openTabs = openTabIds
    ? new Set([...openTabIds].map((x) => String(x).trim()).filter(Boolean))
    : null
  const visited = new Set<string>()

  while (cur && !visited.has(cur)) {
    visited.add(cur)
    const pd = pagesData[cur] as { $parentPageId?: string } | undefined
    const nonIsolated = !isIsolatedPageSlotId(cur)

    if (nonIsolated && pd) return cur
    if (nonIsolated && openTabs?.has(cur)) return cur

    if (isIsolatedPageSlotId(cur)) {
      const up = pd?.$parentPageId
      if (up && up !== 'home') {
        cur = String(up).trim()
        continue
      }
      const registryId = registryFormIdFromSlotId(cur)
      if (registryId !== cur && (pagesData[registryId] || openTabs?.has(registryId))) {
        cur = registryId
        continue
      }
      break
    }

    if (!pd) {
      const registryId = registryFormIdFromSlotId(cur)
      if (registryId !== cur && pagesData[registryId]) {
        cur = registryId
        continue
      }
      if (openTabs?.has(cur)) return cur
      break
    }

    break
  }

  return undefined
}

/** Все слоты pagesData, у которых цепочка $parentPageId ведёт к rootId. */
export function collectDescendantPageSlotIds(
  rootId: string,
  pagesData: Record<string, unknown>,
): string[] {
  const root = String(rootId ?? '').trim()
  if (!root) return []

  const out: string[] = []
  for (const id of Object.keys(pagesData)) {
    if (id === root) continue
    let cur: string | undefined = id
    const visited = new Set<string>()
    while (cur && !visited.has(cur)) {
      visited.add(cur)
      if (cur === root) {
        out.push(id)
        break
      }
      const pd = pagesData[cur] as { $parentPageId?: string } | undefined
      const up = pd?.$parentPageId
      cur = up && up !== 'home' ? String(up).trim() : undefined
    }
  }
  return out
}
